import { Component, inject, input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { INews } from '../../../shared/interfaces/INews';
import { DatePipe } from '@angular/common';
import { SiCardComponent } from '@siemens/element-ng/card';

@Component({
    selector: 'app-news-item',
    templateUrl: './news-item.component.html',
    styleUrls: ['./news-item.component.scss'],
    imports: [DatePipe, SiCardComponent]
})
export class NewsItemComponent {
    public readonly translateService = inject(TranslateService);
    public readonly newsItem = input.required<INews>();
}
